"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplaceCarStartDateWarningWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var moment = require("moment");
var portal_core_1 = require("@ferry/portal-core");
var ReplaceCarStartDateWarningWidget = /** @class */ (function (_super) {
    __extends(ReplaceCarStartDateWarningWidget, _super);
    function ReplaceCarStartDateWarningWidget(props) {
        return _super.call(this, props) || this;
    }
    ReplaceCarStartDateWarningWidget.prototype.render = function () {
        var vehicleMake = "";
        var vehicleModel = "";
        var vehicleRegistrationNumber = "";
        var newStartDate = "";
        var prevVehicle = this.props.interaction.uistate.previousInteractionVehicle;
        if (prevVehicle) {
            vehicleMake = prevVehicle.make;
            vehicleModel = prevVehicle.model;
            vehicleRegistrationNumber = prevVehicle.registrationNumber;
            newStartDate = moment(this.props.interaction.headerInfo.startDate).format("DD MMM YYYY").toString() + ", 23:59";
        }
        return ((0, jsx_runtime_1.jsx)(portal_core_1.InfoBanner, { wording: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["The current cover for ", "".concat(vehicleMake, ", ").concat(vehicleModel, " (").concat(vehicleRegistrationNumber, ") WILL END on ").concat(newStartDate)] }) }));
    };
    return ReplaceCarStartDateWarningWidget;
}(plugin_journey_1.WidgetBase));
exports.ReplaceCarStartDateWarningWidget = ReplaceCarStartDateWarningWidget;
//# sourceMappingURL=ReplaceCarStartDateWarningWidget.js.map